import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private toastr: ToastrService,
        private auth: AuthService
    ) { }

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return next.handle(request).pipe(catchError(err => {
    //         if (err.status === 401 || err.status === 403) {
    //             // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
    //             this.auth.signout();
    //         }
    //         else {
    //             if (err.status === 0) {
    //                 //   this.loaderService.hide();
    //                 this.toastr.error("Coudn't connect to the server OR server not responding", undefined)
    //             }
    //             else if (err.status === 400) {
    //                 this.toastr.error(err.error.error.message ?? `${err.message}\n ${JSON.stringify(err.error?.error)}`, undefined)
    //             }
    //             else if (err.status === 500 && err.error.error.code !== 0) {
    //                 this.toastr.error(err.error.error.message, undefined);
    //             }
    //             // Handle Application/Validation Errors from ABP
    //             else if (err.status === 500) {
    //                 const apiError = err?.error?.error;
    //                 const message = apiError?.message || err.message || 'An error occurred';
    //                 const errorCode = apiError?.code ?? 'Unknown';

    //                 // ✅ Global Duplicate Entry Handling
    //                 if (message.toLowerCase().includes('already exists')) {
    //                     this.toastr.error(message, 'Error');
    //                 }

    //                 // ✅ Global Custom Error Message Handling
    //                 else if (message.toLowerCase().includes('not allowed')) {
    //                     this.toastr.warning(message, 'Permission Denied');
    //                 }

    //                 // ✅ General ABP-style error
    //                 else {
    //                     this.toastr.error(message, 'Error');
    //                 }

    //                 // Optional: Log for developers
    //                 console.error('API Error:', {
    //                     message,
    //                     errorCode,
    //                     details: apiError?.details
    //                 });
    //             }

    //             else {
    //                 this.toastr.error("Something went wrong!", undefined);
    //             }
    //             return throwError(err);
    //         }

    //         const error = err.message || err.statusText;
    //         return throwError(error);
    //     }))
    // }
intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  return next.handle(request).pipe(
    catchError(err => {
      // ✅ Always log detailed info for developer
      if (!request.url.includes('/EnvironmentConfiguration/')) console.error('🔴 API Error Caught by Interceptor:', {
        url: request.url,
        status: err.status,
        statusText: err.statusText,
        message: err?.error?.error?.message || err.message || 'Unknown error',
        details: err?.error?.error?.details || err.error || null
      });

      // ✅ Handle unauthorized / forbidden (auto logout)
      if (err.status === 401 || err.status === 403) {
        this.auth.signout();
      }

      // ❌ Remove ALL toastr/error messages — keep frontend silent
      // (nothing will be shown to user, only logged in console)

      // ✅ Still throw the error (in case app needs to handle it internally)
      return throwError(() => err);
    })
  );
}

}